import {StandingsHeaderDomainModel} from "./standings-header.domain-model";
import {STANDINGS_WIDGET} from "../../../../widgets/standings-widget/standings-widget.consts";
import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";

export class StandingsHeaderViewModel extends BaseViewModel {
  domainModel: StandingsHeaderDomainModel;

  constructor(domainModel: StandingsHeaderDomainModel, isBold: Boolean = false) {
    super();

    this.domainModel = domainModel;
    this.isBold = isBold;
  }

  get key(): String {
    return this.domainModel.key;
  }

  get name(): String {
    return this.domainModel.name;
  }

  get isMajor(): Boolean {
    return this.domainModel.isMajor;
  }

  get isRecentForm(): Boolean {
    return this.key === STANDINGS_WIDGET.CELL_TYPES.recentForm;
  }

  get isDifferenceGoals(): Boolean {
    return this.key === STANDINGS_WIDGET.CELL_TYPES.differenceGoals;
  }

  get isNextMatch(): Boolean {
    return this.key === STANDINGS_WIDGET.NEXT_MATCH_KEY;
  }
}
